import { render, staticRenderFns } from "./DeliveryCostInput.vue?vue&type=template&id=8ad1b906&scoped=true&"
import script from "./DeliveryCostInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryCostInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad1b906",
  null
  
)

export default component.exports